<template>
  <v-container class="mt-6" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <div class="pa-2">
      <v-row>
        <v-col cols="12">
          <p class="white--text">
            The Editor saves a new Release with the status of unpublished. Use
            the Recents area to show this on the website or to subscribers. The
            Editor does not change the status of an already published News
            Release, only the content.
          </p>
        </v-col>
      </v-row>
      <!--  -->
      <template>
        <div class="text-center">
          <v-dialog dark v-model="datepick_show" width="350">
            <v-card>
              <v-card-text>
                <v-date-picker
                  dark
                  v-model="picker"
                  v-if="datepick_show"
                ></v-date-picker>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="accent" text @click="datepick_show = false">
                  Done
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-row v-if="showui">
        <v-col cols="12" md="12">
          <div>
            <!-- launch button -->
            <v-btn class="accent black--text ml-1 mt-1" @click="openeimages">
              Pick Badge Images
            </v-btn>

            <!-- your custom dialog component -->
            <image-picker-dialog
              :images="lst_badge_images"
              :show_dialog.sync="imgDialogVisible"
              :clearimages="clearimages"
              :selectedIds="selectedIds"
              @save="badgesHandleSave"
            />
          </div>
        </v-col>
      </v-row>
      <v-row v-if="showui" dense>
        <v-col
          v-for="(img, index) in getBadgeImages(edit_release)"
          :key="index"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
          class="d-flex justify-center"
        >
          <v-card class="pa-2" outlined>
            <v-img
              :src="img.url"
              contain
              aspect-ratio="1"
              style="width: 150px; height: auto"
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="showui">
        <v-col cols="12" md="6">
          <div class="d-flex flex-row justify-start">
            <v-text-field
              dark
              id="casenum"
              maxlength="8"
              v-model="edit_release.casenum"
              :counter="8"
              label="Case #"
              required
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <date_field
            label="News Date"
            v-model="edit_release.news_date"
          ></date_field>
        </v-col>
      </v-row>
      <v-row v-if="showui">
        <v-col cols="12" md="6">
          <v-text-field
            :rules="reqRules"
            dark
            class="cmpbk_lght white--text"
            maxlength="500"
            v-model="edit_release.release_title"
            :counter="500"
            label="Title"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
            dark
            v-model="edit_release.media_only"
            :label="'Media Only'"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="showui">
        <v-col cols="12" md="4">
          <v-text-field
            :rules="reqRules"
            dark
            class="cmpbk_lght white--text"
            maxlength="500"
            v-model="edit_release.author_name"
            :counter="500"
            label="Author Name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :rules="reqRules"
            dark
            class="cmpbk_lght white--text"
            maxlength="500"
            v-model="edit_release.author_title"
            :counter="500"
            label="Author Title"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            :rules="reqRules"
            dark
            class="cmpbk_lght white--text"
            maxlength="500"
            v-model="edit_release.author_email"
            :counter="500"
            label="Author Email"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="showui">
        <v-col>
          <label class="white--text">Release Text</label>
          <tiptap
            key="n42"
            v-model="edit_release.release_text"
            :characterLimit="editorLimit"
            :htmlLimit="editorLimit"
            :update_tiptap="update_tiptap"
          ></tiptap>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <button
            @click="save_release"
            class="pa-2"
            style="background-color: #1fdeb0; color: black; border-radius: 4px"
          >
            <v-icon small mr-1 title="Save Release">$save</v-icon>
            Save Release
          </button>
          <button
            @click="cancel"
            class="pa-2 ml-2"
            style="background-color: #1fdeb0; color: black; border-radius: 4px"
          >
            <v-icon small mr-1 title="Save Release">$cancel</v-icon>
            Cancel
          </button>
          <!-- <v-btn class="accent black--text ml-1 mt-1" @click="save()">
            <v-icon small mr-1 title="Save Release">$save</v-icon>
            Save
          </v-btn>
          <v-btn
            class="accent black--text ml-1 mt-1"
            @click="cancel()"
            style="background-color: red !important"
          >
            <v-icon small mr-1 title="Cancel release">$cancel</v-icon>
            Cancel
          </v-btn> -->
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import tiptap from "./tiptap.vue";
import date_field from "./date_field.vue";
import { bus_common } from "../mixins/bus_common";
const ImagePickerDialog = () => import("./ImagePickerDialog.vue");

export default {
  name: "add_edit",
  mixins: [bus_common],
  components: { date_field: date_field, tiptap, ImagePickerDialog },
  data: () => ({
    selectedIds: "",
    clearimages: null,
    imgDialogVisible: false,
    lst_badge_images: [],
    showui: false,
    update_tiptap: null,
    editorLimit: 7999,
    picker: "",
    datepick_show: false,
    customTheme: {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      dark: false,
      themes: {
        light: {
          primary: "#FF5722", // Custom primary color
          secondary: "#03A9F4", // Custom secondary color
          background: "#0d1117",
          accent: "#1fdeb0",
          accent2: "#f04336",
          error: "#f44336",
          warning: "#ff9800",
          info: "#03a9f4",
          success: "#4caf50",
          cmpbk_lght: "#363C43",
          cmpbk_drk: "#21262d",
          whitesmoke: "#f5f5f5",
          blacky: "#282623",
          rpdblue: "#00334a",
        },
      },
    },
    edit_release_dev: {
      news_releaseId: 0,
      casenum: "24-12345",
      release_date: "01/01/1900",
      news_date: "11/02/1998",
      website_date: "11/02/1998",
      release_title: "Biggest News Ever",
      release_text: "<p>News text found here!</p>",
      media_only: true,
      author_name: "Chris Johnson",
      author_title: "Public Information Officer",
      author_email: "Johnsonchris@reno.gov",
      badge_image: "3",
    },
    edit_release_new: {
      news_releaseId: 0,
      casenum: "",
      release_date: "01/01/1900",
      news_date: "",
      website_date: "01/01/1900",
      release_title: "",
      release_text: "",
      media_only: false,
      author_name: "Chris Johnson",
      author_title: "Public Information Officer",
      author_email: "Johnsonchris@reno.gov",
      badge_image: "3",
    },
    edit_release: null,
    valid: false,
    firstname: "",
    lastname: "",
    reqRules: [(v) => !!v || "Title is required"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  watch: {
    "$store.state.releasex": function () {
      //keep this
      let self = this;
      this.init();
    },
    picker: function () {
      //     this.edit_release.news_date = this.format_date_us(this.picker).toString();
    },
  },
  methods: {
    getBadgeImages(release) {
      const result = [];

      // no badge string → return empty
      if (!release.badge_image) {
        return result;
      }

      // split the pipe-delimited string into an array of strings
      const parts = release.badge_image.split("|");

      // convert each piece to a number
      const ids = [];
      for (let i = 0; i < parts.length; i++) {
        const num = Number(parts[i]);
        if (!isNaN(num)) {
          ids.push(num);
        }
      }

      // now match each ID to the actual image object
      for (let j = 0; j < ids.length; j++) {
        const id = ids[j];

        for (let k = 0; k < this.lst_badge_images.length; k++) {
          const img = this.lst_badge_images[k];

          if (img.badge_imageId == id) {
            result.push(img);
            break; // found it, move on to next id
          }
        }
      }

      return result;
    },
    save_release() {
      console.log("save_release");
      this.show_loader(true);
      var release_date = this.format_date_sql(
        new Date(this.edit_release.release_date)
      );
      var news_date = this.edit_release.news_date;

      var website_date = this.format_date_sql(
        new Date(this.edit_release.website_date)
      );

      if (this.date_is_valid(news_date) == false) {
        this.swall_it(
          "Save Release Status",
          "News Date is not correct.",
          "warning",
          null,
          null
        );
        console.log("News Date is not correct.");
        return true;
      }
      if (
        this.edit_release.release_title == "" ||
        this.edit_release.release_title == null
      ) {
        this.swall_it(
          "Save Release Status",
          "Title is Empty. Please enter title.",
          "warning",
          null,
          null
        );
        console.log("News Date is not correct.");
        return true;
      }
      if (
        this.edit_release.release_text == "" ||
        this.edit_release.release_text == null
      ) {
        this.swall_it(
          "Save Release Status",
          "Release Text is Empty. Please enter Release Text.",
          "warning",
          null,
          null
        );
        console.log("News Date is not correct.");
        return true;
      }

      this.show_loader(true);
      let formIn = this.mno(this.edit_release);
      this.mrbreakpoint("save");
      //date is in sql format in local var
      formIn.release_date = release_date;
      formIn.news_date = news_date;
      formIn.website_date = website_date;
      formIn.email = this.$store.state.user.email;
      //formIn.badge_image = formIn.badge_image.join("|");
      formIn.apiname = "save_release";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          var lst = self.$store.state.lst_releases;
          lst.push(data);
          self.$store.commit("setLst_releases", lst);
          self.$router.push("/");
          //console.log(data);
          //this.swall_it("Submit Status", "Success.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    openeimages() {
      this.selectedIds = this.edit_release.badge_image;
      this.imgDialogVisible = true;
      this.clearimages = new Date();
    },
    badgesHandleSave(payload) {
      const pipeString = payload.join("|");
      this.edit_release.badge_image = pipeString;
    },
    //get_badge_images
    get_badge_images() {
      console.log("get_badge_images");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "get_badge_images";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.lst_badge_images = self.mno(data);
          self.lst_badge_images.forEach((element) => {
            element.url = "../img/" + element.filename;
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    sync2pick() {
      this.picker = this.format_date_sql(
        this.edit_release.release_date
      ).toString();
    },
    toggle_picker() {
      this.datepick_show = !this.datepick_show;
    },
    message1() {
      alert("This button does nothing yet.");
    },
    save() {},
    cancel() {
      this.$router.push("/");
    },
    init() {
      this.show_loader(false);
      this.get_badge_images();
      if (this.$store.state.releasex.news_releaseId != undefined) {
        //edit
        this.edit_release = this.mno(this.$store.state.releasex);
        this.edit_release.news_date = this.format_date_sql(
          this.edit_release.news_date
        );
      } else {
        //add
        this.edit_release = this.mno(this.edit_release_new);
        this.edit_release.news_date = this.format_date_sql(new Date());
      }

      var self = this;
      setTimeout(() => {
        // self.picker = self.format_date_sql(
        //   new Date(self.edit_release.news_date)
        // );
        self.showui = true;
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
